import DicomPlusGestorSaude from '../../../dicom-plus-gestor-saude/index.vue'
import DicomPlusSoc from '../../../dicom-plus-soc/index.vue'

export default {
  name: 'dicom-plus-modal-tab-estudo',
  inject: ['dicomPlusModal'],
  components: { DicomPlusGestorSaude, DicomPlusSoc },
  computed: {
    m() {
      return this.dicomPlusModal
    }
  }
}
